/*
 * @Author: your name
 * @Date: 2021-09-07 08:54:41
 * @LastEditTime: 2022-01-05 09:11:57
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// 导入组件库
import '@/assets/css/reset.css'
import ElementUI from "element-ui"
import '@/assets/css/main.css'
import '@/assets/css/goodList.css'
import '@/assets/css/personalTable.css'
import '@/assets/css/stroke.css'


// 导入样式
import "element-ui/lib/theme-chalk/index.css"

import vueEsign from 'vue-esign'
Vue.use(vueEsign)

// 注册为全局组件
Vue.use(ElementUI)
Vue.use(require('vue-moment'))

// 引入在线客服js
// import customerService from '@/utils/customerService.js'
// Vue.prototype.customerService = customerService

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js